import { render, staticRenderFns } from "./changeCourseModal.vue?vue&type=template&id=6b3ff2f8&scoped=true"
import script from "./changeCourseModal.vue?vue&type=script&lang=js"
export * from "./changeCourseModal.vue?vue&type=script&lang=js"
import style0 from "./changeCourseModal.vue?vue&type=style&index=0&id=6b3ff2f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3ff2f8",
  null
  
)

export default component.exports